import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    padding: theme.spacing.space16,
    flexDirection: "column",
    gap: theme.spacing.space16,
  },
  serviceIcon: {
    width: 30,
    height: 30,
  },
}));
